import { render } from "./DexHeaderCell.vue?vue&type=template&id=6e2bfc90"
import script from "./DexHeaderCell.vue?vue&type=script&lang=js"
export * from "./DexHeaderCell.vue?vue&type=script&lang=js"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__